import { Divider, Stack, Typography } from '@mui/material';
import React from 'react';
import { ContactCaptureBasicsSection } from './ContactCaptureBasicsSection';
import { ContactCaptureCopySection } from './ContactCaptureCopySection';
import { ContactCaptureFieldList } from './ContactCaptureFieldsSection';
import { OverlineLabel } from './OverlineLabel.styles';


export const ContactCaptureContentTab = () => (
  <Stack spacing={3}>
    <ContactCaptureBasicsSection />
    <Divider />
    <ContactCaptureCopySection />
    <Divider />

    <Stack spacing={1}>
      <OverlineLabel>Contact fields</OverlineLabel>
      <Typography variant="caption" color="text.secondary" sx={{ mt: -0.5, mb: 1 }}>
        Add the fields the widget shows and rename their labels. Mobile phone is always collected.
      </Typography>
      <ContactCaptureFieldList />
    </Stack>
  </Stack>
);
